import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {organizationSettingsActions} from "_actions";

export default function useGetTrendsMsgDataSources(organizationTrendsId) {
    const dispatch = useDispatch();

    useEffect(() => {
        if (organizationTrendsId) {
            dispatch(organizationSettingsActions.fetchTrendsMsgDataSources(organizationTrendsId));
        }
    }, [organizationTrendsId]);

    const organizationSettings = useSelector(state => state.organizationSettings);
    const trendsMsgDataSources = organizationSettings.trendsMsgDataSources || [];
    const loading = organizationSettings.loadingTrendsMsgDataSources;

    return {trendsMsgDataSources, loading};
}
